import $ from "../lib/jquery.js";

/*
 * reCAPTCHA v3 or v2 invisible, whichever Savi\Recaptcha rendered.
 *
 * Both put the same hidden field in the form — .recaptcha-token, carrying a
 * data-version attribute — so form.js only has to ask for a token and write
 * it into the field. v3 executes against the site key directly; v2 executes
 * the widget and waits for Google to call data-callback.
 *
 * The token is verified server side in content/inc.form-submission.php —
 * there is deliberately no client-side "is it valid?" round trip, because a
 * bot would simply skip it.
 */

let pending = null;

function tokenField() {
  return $(".recaptcha-token").first();
}

export function hasRecaptcha() {
  return typeof window.grecaptcha !== "undefined" && tokenField().length > 0;
}

/**
 * Ask Google for a token. `onToken` receives it, or `onError` runs if the
 * token could not be obtained at all.
 */
export function executeRecaptcha(onToken, onError) {
  const $field = tokenField();

  const fail = (error) => {
    console.error("reCAPTCHA failed to execute", error);
    pending = null;
    onError?.(error);
  };

  if ($field.data("version") === "v3") {
    try {
      window.grecaptcha.ready(() => {
        window.grecaptcha
          .execute($field.data("sitekey"), { action: $field.data("action") || "submit" })
          .then(onToken)
          .catch(fail);
      });
    } catch (error) {
      fail(error);
    }

    return;
  }

  // v2 invisible: the token arrives via the global callback below.
  pending = onToken;

  try {
    window.grecaptcha.execute();
  } catch (error) {
    fail(error);
  }
}

export default function initRecaptcha() {
  // Google invokes this by name, from the widget's data-callback attribute.
  window.saviRecaptchaCallback = (token) => {
    const onToken = pending;
    pending = null;
    onToken?.(token);
  };
}
